
document.addEventListener('DOMContentLoaded', function() {
  if(window.innerWidth < 750){
    $('.flex-grid-row .multicolumn-list').slick({  
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true
    });
  }  
})